import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SubTitle, Image, styled, CommonStyles } from '@teko/ds-desktop';

const PolicyAndService = (_a) => {
    var { title, information } = _a, rest = __rest(_a, ["title", "information"]);
    return (jsxs(Wrapper, Object.assign({}, rest, { children: [jsx(SubTitle, Object.assign({ level: 2, weight: "medium", marginBottom: "s8" }, { children: title }), void 0), information.map((info, index) => (jsxs(Policy, { children: [typeof info.icon === 'string' ? (jsx(Image, { src: info.icon, width: 24, height: 24 }, void 0)) : (info.icon), jsx(Content, { dangerouslySetInnerHTML: { __html: info.content } }, void 0)] }, index)))] }), void 0));
};
const Wrapper = styled.div `
  ${CommonStyles}
  background-color: #fff;
  border-radius: 0.5rem;
`;
const Policy = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
`;
const Content = styled.div `
  flex: 1;
`;

export { PolicyAndService as P };
